export class Colleague {
    public MATERIAL_GROUP_ID: string;
    public MATERIAL_GROUP: string;
    public MATERIAL_GROUP_DESCRIPTION: string;
    public PURCHASER_CODE: string;
    public NAME: string;
    public ROLE: string;
    public FUNCTION_NAME: string;
    public BRAND: string;
    public INS_DATE: string;
    constructor(data: any) {
        this.MATERIAL_GROUP_ID = data.MATERIAL_GROUP_ID;
        this.MATERIAL_GROUP = data.MATERIAL_GROUP;
        this.MATERIAL_GROUP_DESCRIPTION = data.MATERIAL_GROUP_DESCRIPTION;
        this.PURCHASER_CODE = data.PURCHASER_CODE;
        this.NAME = data.NAME;
        this.ROLE = data.ROLE;
        this.FUNCTION_NAME = data.FUNCTION_NAME;
        this.BRAND = data.BRAND;
        this.INS_DATE = data.INS_DATE;
    }
}